export default "__VITE_ASSET__6e042f32__"